import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { AppConfig } from '../../AppConfig';
import { ScheduleCampaignDialog } from '../../components/ScheduleCampaignDialog';
import { SearchBar } from '../../common/components/SearchBar';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Toast } from '../../components/Toast';

export class CampaignsDisplay extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'CampaignsDisplay'
    this.pageTitle = Helper.getString('campaigns')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['miscs','campaigns'], queryParams: { groupId: this.orgId, pb: 'fieldDef', state:'LIVE' } }
    ]
    if(this.orgId && this.orgId !== 'PRODUCT') this.toFetch.push({ method: 'GET', paths: ['orgs', this.orgId] })
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        return (
          <Fragment>
            <div>{current.title}</div>
            <small>ID: {current.id}</small>
          </Fragment>
        )
      },
      Type: (current) => {
        if(current.state === 'LIVE') {
          return AppUiHelper.chipLive(current.state)
        } else if(current.state === 'DISABLED') {
          return AppUiHelper.chipDisabled(current.state)
        }
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.addNewLabel = 'Create Campaign'
    this.noTableHead = true
    this.allowAccessToRoles = ['CAMPAIGNS']
    if(!UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      this.noAdd = true
    }
  }

  onFetchSuccess(results) {
    this.org = results.length >= 2 ? results[1] : null // organization details
    this.formDefinition = this.fieldDef = results[0].fieldDef
    const options = {
      fieldKey: 'state',
      keyToReplace: 'LIVE',
      replaceWithValue: 'ENABLED',
    }
    this.formDefinition = AppHelper.changeFieldOptionLabel(this.formDefinition, options)
    if (this.orgId !== 'PRODUCT') {
      const f = this.formDefinition.steps[0].fields.find((i) => i.key === 'hrSpots')
      if(f) f.hide = true
    }
    const stateField = this.formDefinition.steps[0].fields.find(i => i.key === 'state')
    stateField.options = stateField.options.filter(i => ['LIVE', 'DISABLED'].includes(i.key))
    this.setState({
      items: results[0].items,
      stateFilterValue: 'LIVE',
      searchText: ''
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', current.id]),
    });
  }

  onActions(current) {
    const actions = []

    UiHelper.addActionButtonByRole(actions, this.campaignsMedia(current))

    // UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    // actions.push(UiHelper.buttonDelete(this, current))
    // if (!AppConfig.FEATURES_OFF.includes('CAMPAIGN_SCHEDULE') || AppHelper.hasFeature(this.org, 'REGVENUE')) { // Schedule Campaign --
    //   UiHelper.addActionButtonByRole(actions, this.scheduleCampaignButton(current), this.allowAccessToRoles)
    // }
    // if(this.orgId && !AppConfig.FEATURES_OFF.includes('BULK_ATTACH_DETACH_VENUE')) { // Display Attached venues & Attach Detach--
    //   UiHelper.addActionButtonByRole(actions, this.venueBulkAttachDetachButton(current), this.allowAccessToRoles)
    // }
    return actions
  }

  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  campaignsMedia(current) {
    if(AppHelper.isMobileview()) {
      return (
        <Tooltip title='Media' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)} onClick={() => {
            this.setState({
              toastMsg: Helper.getString('notSupported'),
              showToast: true,
              severity: 'error'
            })
          }}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      )
    }
    return (
      <Link to={this.baseRoute() + '/campaigns/' + current.id} key={current.id + '-items'}>
        <Tooltip title='Details' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  venueBulkAttachDetachButton(current) {
    return (
      <Link to={this.baseRoute() + '/campaigns/' + current.id + '/screens'} key={current.id + '-items'}>
        <Tooltip title={Helper.getString('listVenues')} placement='top-start' key={current.id + '-venues'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>storefront</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  scheduleCampaignButton(current) {
    return (
      <Tooltip title={Helper.getString('scheduleCampaign')} placement='top-start' key={current.id + '-schedule-items'}>
        <span className={css(AppStyles.entityTableLinkIcon)} onClick={() => { this.setState({ currentScheduleItem: current, showScheduleOptions: true }) }}>
          <i className='material-icons-outlined'>update</i>
        </span>
      </Tooltip>
    )
  }


  onList() {
    this.setState({ searchText: '', inProcessOnList: true, stateFilterValue: 'LIVE' }, () => { this.onFetchCampaign() })
  }

  onSearch = (searchText) => {
    this.setState({ searchText: searchText, inProcessSearch: true }, () => { this.onFetchCampaign() })
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue:selectedState
    })
  }

  getQueryParams() {
    const queryParams = { groupId: this.orgId, pb: 'fieldDef' }
    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }
    return queryParams
  }

  onFetchCampaign() {
    ApiHelper.call(
      {
        method: 'GET', paths: ['miscs','campaigns'], queryParams: this.getQueryParams()
      },
      function (err, data) {
        console.log(err, data)
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            items: [],
            inProcessSearch: false,
            inProcessOnList: false
          })
          return
        }
        this.setState({
          successMsg: '',
          errMsg: null,
          items: data.items,
          inProcessSearch: false,
          inProcessOnList: false
        })
      }.bind(this));
  }

  renderAboveTable() {
    return (
      <Fragment>
        {this.getToast()}
        <ScheduleCampaignDialog
          current={this.state.currentScheduleItem}
          successCallback={() => { this.setState({ showScheduleOptions: false }); this.fetchItems() }}
          title={Helper.getString('scheduleCampaign')}
          isOpen={this.state.showScheduleOptions ? true : false}
          onClosed={() => this.setState({ showScheduleOptions: false })}
        />
        <div className={css(Styles.searchContainer)}>
          <SearchBar
            hint={'Search'}
            inProcessSearch={this.state.inProcessSearch || false}
            inProcessOnList={this.state.inProcessOnList || false}
            onList={this.onList.bind(this)}
            onSearch={this.onSearch.bind(this)}
            searchText={this.state.searchText}
            onSinglePickerFilter={this.onStateFilter.bind(this)}
            singleSelectPicker={
              {
                options: [
                  { key: 'LIVE', value: 'ENABLED' },
                  { key: '_ALL', value: 'ALL' },
                  { key: 'DISABLED', value: 'DISABLED' }
                ],
                defaultValue: this.state.stateFilterValue,
                // title: 'Select State'
              }
            }
            showRecentButtonText={'Reset Filter'}>
          </SearchBar>
        </div>
      </Fragment>
    )
  }

}
const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  searchContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CampaignsDisplay.js